<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="modal-title">{{ $t('whatIsCoreEventFee') }}</div>
      <p class="modal-description">
        {{ $t('coreEventFeeDescription') }}
      </p>
      <main-button
        depressed
        color="#333"
        :text="$t('understand')"
        style="width: 100%"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'core-event-fee-description-modal',
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.modal {
  color: #333;
  max-width: 24.3125rem;
  display: flex;
  padding: 2rem 2rem 2.5rem 2rem;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2rem;

  border-radius: 0.25rem;
  border: 1px solid rgba(151, 151, 151, 0.5);
  background: #fff;

  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.04), 0 0 12px 0 rgba(0, 0, 0, 0.04);
}
.modal::-webkit-scrollbar {
  display: none;
}
@media screen and (max-width: 1000px) {
  .modal {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}
.modal-title {
  align-self: stretch;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}
.modal-description {
  align-self: stretch;
  font-family: Source Sans Pro;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
</style>
